<div class="ai-disclaimer-dialog">
  <header class="ai-disclaimer-dialog__header">
    <h2 class="ai-disclaimer-dialog__title">
      <i class="ri-information-line ai-disclaimer-dialog__icon" aria-hidden="true"></i>
      <span>{{ 'ai.disclaimer.title' | translate }}</span>
    </h2>
  </header>

  <div class="ai-disclaimer-dialog__body" role="note">
    <p class="ai-disclaimer-dialog__text" [innerHTML]="'ai.disclaimer.orientative' | translate"></p>
    <p class="ai-disclaimer-dialog__text" [innerHTML]="'ai.disclaimer.professional_review' | translate"></p>
  </div>

  <footer class="ai-disclaimer-dialog__footer">
    <button
      mat-stroked-button
      color="primary"
      type="button"
      class="ai-disclaimer-dialog__accept-btn"
      data-cy="ai-disclaimer-accept"
      cdkFocusInitial
      (click)="accept()"
    >
      {{ 'ai.disclaimer.accept' | translate }}
    </button>
  </footer>
</div>
